<template>
  <div>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="dateFormatted"
          :label="label"
          hide-details="auto"
          class="datainput justify-content-end align-self-center pb-1"
          dense
          outlined
          readonly
          :clearable="clearable"
          @click:clear="clearButtonClicked"
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="date"
        no-title
        type="month"
        :landscape="false"
        :locale="$locale"
        multiple
        @mouseout="menu = false"
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    clearable: Boolean,
    value: {
      type: Array,
      default: () => [], // Ensure default is an empty array
    },
  },

  data() {
    return {
      menu: false,
      date: this.value, // Initialize date with prop value
      dateFormatted: "",
    };
  },

  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.date = val; // Sync local date with prop value
        this.updateFormattedDate();
      },
    },

    date(val) {
      this.$emit("input", val); // Emit updated date value
      this.updateFormattedDate();
    },
  },

  methods: {
    clearButtonClicked() {
      this.date = []; // Clear selected dates
    },

    updateFormattedDate() {
      if (!this.date || this.date.length === 0) {
        this.dateFormatted = "";
        return;
      }
      // Format dates as "Month Year"
      const formattedDates = this.date.map((d) =>
        new Date(d).toLocaleDateString(this.$i18n.locale, {
          // year: "numeric",
          month: "short",
        })
      );

      this.dateFormatted = formattedDates.join(", "); // Join dates with a comma
    },
  },
};
</script>
